<template>
  <BaseModal modal-content-class="unsub">
    <div class="content">
      <h1>{{ $_translations.value.modal_unsubscribe_success_title }}</h1>

      <BaseImage
        src="/static/images/modals/unsubscribe/unsubscribe_icon.svg"
        alt="unsubscribe icon"
        image-class="top_img"
      />

      <p>{{ $_translations.value.modal_unsubscribe_success_description }}</p>

      <p>{{ $_translations.value.modal_unsubscribe_success_additional_info }}</p>

      <BaseButton
        container-class="resub_btn"
        :disabled="submitting"
        @click:button="handleProceed"
      >
        {{ $_translations.value.modal_unsubscribe_success_button_proceed }}
      </BaseButton>

      <ResubscribeTermsSection />
    </div>
  </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import ResubscribeTermsSection from '@/components/subscription/section/ResubscribeTermsSection.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import useIntegrationStore from '@/store/modules/integration.js';

const emits = defineEmits(['resubscribe:viaSuccessUnsub']);

const appSettingsStore = useAppSettingsStore();
const authStore = useAuthStore();
const integrationStore = useIntegrationStore();

const submitting = ref(false);

const handleProceed = async () => {
  try {
    submitting.value = true;

    await integrationStore.dispatchIntegrationResubscribeViaWebReoptin();
    await authStore.dispatchRetrieveAuthUser();

    if (appSettingsStore.appProperties.isReoptinOneStep && authStore.user.subscribed) {
      emits('resubscribe:viaSuccessUnsub', { status: 'success' });
    } else if (!appSettingsStore.appProperties.isReoptinOneStep && !authStore.user.subscribed) {
      emits('resubscribe:viaSuccessUnsub', { status: 'pinRequired' });
    } else {
      emits('resubscribe:viaSuccessUnsub', { status: 'error' });
    }
  } catch {
    emits('resubscribe:viaSuccessUnsub', { status: 'error' });
  } finally {
    submitting.value = false;
  }
};
</script>
